import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "@tanstack/react-router";
import { IconButton } from "bi-lib";
import { PropsWithChildren } from "react";

export interface PageTitleProps {
    suppressBackButton?: boolean;
    from?: string;
}

export default function PageTitle({ children, suppressBackButton = false, from }: PropsWithChildren<PageTitleProps>) {
    const location = useLocation();
    const isFirstChild = location.pathname.indexOf("/") == location.pathname.lastIndexOf("/");

    return (
        <Box p={1} mb={2} borderBottom={"1px solid grey"} display={"flex"} alignItems={"center"} gap={1}>
            {!suppressBackButton && !isFirstChild && (
                <Link to={from ?? ".."}>
                    <IconButton tooltip={"Back"} size={"small"}>
                        <ArrowBackIcon />
                    </IconButton>
                </Link>
            )}
            <Typography variant={"h5"}>{children}</Typography>
        </Box>
    );
}
